export function createSafeCaster<T extends string>(choices: T[]): (value: unknown) => T | undefined;
export function createSafeCaster<T extends string>(
  choices: T[],
  defaultValue: NoInfer<T>,
): (value: unknown) => T;
export function createSafeCaster<T extends string>(choices: T[], defaultValue?: NoInfer<T>) {
  return function (value: unknown): T | undefined {
    if (typeof value !== 'string' || !choices.includes(value as T)) {
      return defaultValue;
    }

    return value as T;
  };
}
